
  


import React, { useState } from 'react';
import "../../../styles/settingStyle.css"
import AccountSettings from './AcountSettings';
import NotificationSettings from './NotificationSettings';
import BillingSettings from './BillingSettings';
import accountIcon from "../../../assets/setting-account.svg"
import notificationIcon from "../../../assets/setting_not.svg"
import billingIcon from "../../../assets/setting_billing.svg"

const Setting = () => {
  const [activeTab, setActiveTab] = useState("account");

  return (
       <div className='jobpost-dashboard' style={{ minHeight: "100vh", padding: "20px", marginTop: "91px", display: "flex", flexDirection: "column", gap: "10px" }}>
    <div className='setting-container'>
      <div className="setting-sidebar">
        <ul>
          <li
            className={activeTab === "account" ? "setting-active" : ""}
            onClick={() => setActiveTab("account")}
          >
            <img src={accountIcon} alt="account"/>Account
          </li>
          <li
            className={activeTab === "notification" ? "setting-active" : ""}
            onClick={() => setActiveTab("notification")}
          >
            <img src={notificationIcon} alt="notification"/>Notification
          </li>
          <li
            className={activeTab === "billing" ? "setting-active" : ""}
            onClick={() => setActiveTab("billing")}
          >
            <img src={billingIcon} alt="billling"/>Billing
          </li>
        </ul>
      </div>

      <div className="setting-content">
        {activeTab === "account" && <AccountSettings />}
        {activeTab === "notification" && <NotificationSettings />}
        {activeTab === "billing" && <BillingSettings />}
      </div>
    </div>
      </div>
  );
};

export default Setting;
